import React from "react";
import { Card, CardContent, Typography, Box, Tooltip } from "@mui/material";
import styles from "../../styles/launchDetails/testLaunchPrimaryReportsCard.module.scss";

export const TestLaunchPrimaryReportsCard = ({
  title,
  value,
  icon,
  iconColor,
  subText,
  tooltip,
}) => {
  const card = (
    <Card className={styles['primary-reports-card']}>
      <CardContent className={styles['card-content']}>
        <Box className={styles['card-main-content']}>
          {/* Left Section */}
          <Box className={styles['card-left-section']}>
            <Typography
              variant="body2"
              className={styles['card-title']}
            >
              {title}
            </Typography>
            <Typography
              variant="h6"
              className={styles['card-value']}
            >
              {value}
            </Typography>
          </Box>

          {/* Icon */}
          {icon &&
            React.cloneElement(icon, {
              className: styles['card-icon'],
              style: { color: iconColor || "#2563EB" },
            })}
        </Box>

        {/* Subtext */}
        {subText && (
          <Typography
            variant="caption"
            className={styles['card-subtext']}
          >
            {subText}
          </Typography>
        )}
      </CardContent>
    </Card>
  );

  if (!tooltip) {
    return card;
  }

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <Box className={styles['tooltip-card-wrapper']}>{card}</Box>
    </Tooltip>
  );
};

export const GroupCardRendering = ({ cards = [] , style = {} }) => {
  return (
    <Box className={styles['group-card-container']} sx={style}>
      {cards.map((card, idx) => (
        <Box key={idx} className={styles['group-card-item']}>
          <TestLaunchPrimaryReportsCard {...card} />
        </Box>
      ))}
    </Box>
  );
};
